import { FC, useRef } from 'react';
import { SliderImage, SliderVideo } from '@/components/common/Gallery/styles';
import { GalleryItemProps } from '@/components/common/Gallery/types';

export const GalleryItem: FC<GalleryItemProps> = ({ item, index, onPointerUp = () => {}, inFullScreen, isNotesGallery }) => {
  const imageRef = useRef(null);

  if (item.endsWith('.jpg') || item.endsWith('.png') || item.endsWith('.gif') || item.endsWith('.webp')) {
    return (
      <div ref={imageRef} style={{ width: '100%', height: '100%', position: 'relative', background: isNotesGallery && !inFullScreen ? '#D0D5DD' : 'transparent', borderRadius: isNotesGallery ? '8px' : 0 }}>
        <SliderImage src={item} onPointerUp={onPointerUp} inFullScreen={inFullScreen} isNotesGallery={isNotesGallery} />
      </div>
    );
  }

  if (item.endsWith('.mp4') || item.endsWith('.webm') || item.endsWith('.ogg')) {
    return (
      <div ref={imageRef} style={{ width: '100%', height: '100%', position: 'relative' }}>
        <SliderVideo controls style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
          <source src={item} type={`video/${item.split('.').pop()}`} />
          Your browser does not support the video tag.
        </SliderVideo>
      </div>
    );
  }

  if (item.includes('youtube.com') || item.includes('vimeo.com') || item.endsWith('.pdf')) {
    return <iframe src={item} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen title={`iframe-${index}`} style={{ width: '100%', height: '100%' }} />;
  }

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'gray' }}>
      <p>Unsupported content type</p>
    </div>
  );
};
